import React, { useEffect } from "react";
import { Button, Drawer } from "antd";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { requestHandler } from "../../../shared/utils/helpers";
import { useNavigate } from "react-router-dom";
import translate from "../../../shared/utils/translations";

const TicketsDrawer = ({ isDrawer, setDrawer, selectedTicket }) => {
  const navigate = useNavigate();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  const sendMessage = async () => {
    setBtnLoading(true);
    if (!message) {
      toast.error(translate("Please enter a message!"));
      setBtnLoading(false);
      return;
    }
    const allMessages = await requestHandler(
      "put",
      `/tickets/message/${selectedTicket?.id}`,
      { message },
      true,
      navigate,
      "/login"
    );
    if (allMessages) {
      toast.success(translate("Message sent successfully!"));

      setBtnLoading(false);
      setMessage("");
      setMessages(allMessages.data);
    }
  };
  const getMessages = async (ticketId) => {
    const messages = await requestHandler(
      "get",
      `/tickets/${ticketId}`,
      null,
      true,
      navigate,
      "/login"
    ).then((res) => {
      console.log(res);
      setMessages(res?.data);
    });
    return messages;
  };

  useEffect(() => {
    setMessage("");
    setMessages([]);
    selectedTicket?.id && getMessages(selectedTicket?.id);
    console.log("selectedTicket", selectedTicket);
  }, [selectedTicket]);

  useEffect(() => {
    console.log("messages", messages);
  }, [messages]);

  useEffect(() => {
    setMessage("");
    setMessages([]);
  }, [isDrawer]);

  return (
    <>
      <Drawer
        title={selectedTicket?.subject}
        placement="right"
        onClose={() => setDrawer(false)}
        open={isDrawer}
        width={"50%"}
      >
        <>
          <div className="messages__wrapper">
            <div className="messages__inner">
              <div className="messages__date">
                {selectedTicket?.created_at?.replace("T", "-")?.split(".")[0]}
              </div>
              <div className="messages__list">
                {messages?.length ? (
                  messages?.map((message) => {
                    if (message?.from !== "me") {
                      return (
                        <div className="messages__author" key={messages?.id}>
                          <div className="messages__text">
                            {message?.message}
                          </div>
                          <div className="messages__time">
                            {
                              message?.created_at
                                ?.replace("T", "-")
                                ?.split(".")[0]
                            }
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <>
                          <div className="messages__text">
                            {message?.message}
                          </div>
                          <div className="messages__time">
                            {
                              message?.created_at
                                ?.replace("T", "-")
                                ?.split(".")[0]
                            }
                          </div>
                        </>
                      );
                    }
                  })
                ) : (
                  <div className="no__msgs_warn">
                    <img src="/assets/img/multimedia.svg"></img>
                  </div>
                )}
              </div>
            </div>
            <div className="subscription">
              <textarea
                className="subscription__input"
                type="text"
                name="text"
                value={message}
                placeholder={translate("Type here...")}
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                required="required"
              />
              <button className="subscription__btn cvv" onClick={sendMessage}>
                {isBtnLoading ? (
                  <span className="btn-spinner"></span>
                ) : (
                  <svg className="icon icon-arrow-next">
                    <use xlinkHref="#icon-arrow-next"></use>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </>
      </Drawer>
    </>
  );
};

export default TicketsDrawer;
